export default __webpack_public_path__ + "static/media/HEPrivateQuestionnaire.e3e08e84.xls";